
import React from "react";
import {
  FiList,
  FiCheckSquare,
  FiUsers,
  FiMessageSquare,
  FiFolder,
  FiCreditCard,
  FiFileText,
  FiBriefcase,
  FiBarChart2,

  FiUser,
} from "react-icons/fi";
import { FaFile, FaFileAlt, FaGavel, FaWarehouse, FaUserCheck, FaFolderOpen, FaUserCircle } from "react-icons/fa";

const menuItems = [
  {
    label: "PROGRAMS",
    icon: <FiBriefcase />,
    path: "/program-dashboard",
  },

  { label: "Projects", icon: <FiBriefcase />, path: "/pm/projects" },
  { label: "Activities", icon: <FiList />, path: "/pm/activitiespage" },
  { label: "Tasks", icon: <FiCheckSquare />, path: "/pm/tasks" },
  { label: "Procurement", icon: <FiFolder />, path: "/pm/procurement" },
  { label: "Asset Inventory", icon: <FaWarehouse />, path: "/program-assets" },
  { label: "Projects Inventory", icon: <FaWarehouse />, path: "/project-inventory" },

  { label: "Project Requirement Requests", icon: <FaFolderOpen />, path: "/project-requests" },
  { label: "Disciplinary", icon: <FaGavel />, path: "/pm-discipline" },




  {
    label: "Timesheet",
    icon: <FaFileAlt />,
    path: "/pm/timesheet"
  },
  {
    label: "Documentation",
    icon: <FaFile />,
    path: "/pm/documentation"
  },
  { label: "My Profile", icon: <FaUserCircle />, path: "/pm-profile" },

];

export default menuItems;